<template>
  <footer id="footer">
    <p>
      <a href="https://www.linkedin.com/in/ivan-rozhkov-3769ba111/" target="_blank" rel="noopener noreferrer">
        <font-awesome-icon :icon="['fab', 'linkedin']" /> LinkedIn
      </a>
      &nbsp; || &nbsp;
      <a href="https://t.me/ivanrozhkov" target="_blank" rel="noopener noreferrer">
        <font-awesome-icon :icon="['fab', 'telegram']" /> Telegram
      </a>
    </p>
  </footer>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLinkedin, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faLinkedin, faTelegram);

export default {
  name: 'FooterComponent',
  components: {
    FontAwesomeIcon
  }
};
</script>

<style scoped>
#footer {
  background: linear-gradient(135deg, #2c3e50, #34495e);
  color: #fff;
  text-align: center;
  padding: 1.25rem 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  background-color: rgba(44, 62, 80, 0.95);
  z-index: 999;
}

#footer a {
  color: #fff;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 400;
  position: relative;
}

#footer a:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

#footer a:active {
  transform: translateY(0);
}

#footer p {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* Icon styling */
#footer .svg-inline--fa {
  font-size: 1.1rem;
  transition: transform 0.3s ease;
}

#footer a:hover .svg-inline--fa {
  transform: scale(1.1);
}

/* Separator styling */
#footer p::after {
  content: '';
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  #footer p {
    font-size: 0.9rem;
  }
  
  #footer a {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }
  
  #footer {
    padding: 1rem 0;
  }
}
</style>
